import { Divider, Menu, MenuItem, Typography } from "@mui/material";
import type { Ref } from "react";
import { CalculationType } from "../../../../../../../../../api/types/fieldConfigurationTypes";
import DateCalculationMenuItem from "./DateCalculationMenuItem";
import { calculationTypeCapabilities } from "./utilities/calculationTypeCapabilities";
import type { DateCalculationType } from "./utilities/dateCalculationTypes";

interface Props {
  ref?: Ref<HTMLDivElement>;
  selectedCalculationType: CalculationType | undefined;
  calculationMenuItemAnchor: HTMLElement | null;
  onClose: (event: React.MouseEvent<HTMLElement>) => void;
  onCustomCalculationItemClick: (calculationType: CalculationType, event: React.MouseEvent<HTMLElement>) => void;
  availableCalculationTypeOptions: CalculationType[];
  onDateCalculationItemClick?: (type: DateCalculationType, event: React.MouseEvent<HTMLElement>) => void;
}
const CustomCalculationOptionsMenu = ({
  ref,
  selectedCalculationType,
  calculationMenuItemAnchor,
  onClose,
  onCustomCalculationItemClick,
  availableCalculationTypeOptions,
  onDateCalculationItemClick,
}: Props) => {
  const shouldRenderCustomFormulaDivider =
    availableCalculationTypeOptions[0] === CalculationType.CustomFormula &&
    (availableCalculationTypeOptions.length > 1 || !!onDateCalculationItemClick);

  return (
    <Menu
      ref={ref}
      open={!!calculationMenuItemAnchor}
      anchorEl={calculationMenuItemAnchor}
      onClose={onClose}
      //*Keeps cursor pointer for the main menu item
      sx={{ pointerEvents: "none" }}
      slotProps={{ paper: { sx: { pointerEvents: "auto", minWidth: 200 } } }}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
    >
      {availableCalculationTypeOptions.flatMap((option, index) => {
        const menuItem = (
          <MenuItem
            key={option}
            selected={selectedCalculationType === option}
            onClick={(event) => onCustomCalculationItemClick(option, event)}
          >
            <Typography>{calculationTypeCapabilities[option].caption}</Typography>
          </MenuItem>
        );

        if (!shouldRenderCustomFormulaDivider || index !== 0) {
          return [menuItem];
        }

        return [menuItem, <Divider key={`${option}-divider`} />];
      })}
      {onDateCalculationItemClick && (
        <DateCalculationMenuItem onDateCalculationItemClick={onDateCalculationItemClick} />
      )}
    </Menu>
  );
};

export default CustomCalculationOptionsMenu;
